function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("g", null, React.createElement("path", {
  d: "M17.5,35 C7.83501688,35 0,27.1649831 0,17.5 C0,7.83501688 7.83501688,0 17.5,0 C27.1649831,0 35,7.83501688 35,17.5 C35,27.1649831 27.1649831,35 17.5,35 Z M16.1691198,17.9703082 L12.4424491,21.6969789 C12.0519248,22.0875032 12.0519248,22.7206682 12.4424491,23.1111925 C12.8329734,23.5017168 13.4661383,23.5017168 13.8566626,23.1111925 L17.5833333,19.3845218 L21.310004,23.1111925 C21.7005283,23.5017168 22.3336933,23.5017168 22.7242176,23.1111925 C23.1147419,22.7206682 23.1147419,22.0875032 22.7242176,21.6969789 L18.9975469,17.9703082 L22.7242176,14.2436375 C23.1147419,13.8531133 23.1147419,13.2199483 22.7242176,12.829424 C22.3336933,12.4388997 21.7005283,12.4388997 21.310004,12.829424 L17.5833333,16.5560947 L13.8566626,12.829424 C13.4661383,12.4388997 12.8329734,12.4388997 12.4424491,12.829424 C12.0519248,13.2199483 12.0519248,13.8531133 12.4424491,14.2436375 L16.1691198,17.9703082 Z"
}))));

const SvgEndSessionHoverIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "35px",
  height: "35px",
  viewBox: "0 0 35 35",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgEndSessionHoverIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/end-session-hover-icon.5e8affb4.svg";
export { ForwardRef as ReactComponent };